import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {Handler} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {ChromelessButton} from '../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {Icon} from '../../../../libs/shared/ui/src/components/icon/icon';
import {VisuallyHidden} from '../../../../libs/shared/ui/src/components/visuallyHidden/visuallyHidden';
import {styled} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface BannerCloseActionProps {
  onClick: Handler;
  className?: string;
  interactionId?: string;
}

/*
 * Style.
 */

export const StyledCloseButton = styled(ChromelessButton)`
  cursor: pointer;
  grid-area: action;
  padding: 5px;
  border-radius: 50%;
  color: ${(p) => p.theme.banner};

  &:hover {
    background-color: ${(p) => p.theme.bannerActionHover};
  }
`;

/*
 * Component.
 */

export const BannerCloseAction: FC<BannerCloseActionProps> = (props) => (
  <StyledCloseButton onClick={props.onClick} className={props.className} interactionId={props.interactionId}>
    <Icon name="closeSmall" />
    <VisuallyHidden>
      <Trans id="banner-close">Close</Trans>
    </VisuallyHidden>
  </StyledCloseButton>
);
